export const init = () => {
  const dimensions = {
    1679: [756, 426],
    1279: [515, 343],
    991: [697, 426],
    768: [532, 354],
    479: [640, 426],
    0: [300, 200],
  };

  const $mapStaticContainer = $('#map-static');
  const $mapStaticImg = $mapStaticContainer.find('img');

  const updateStaticMapSize = () => {
    const windowWidth = window.innerWidth;

    let width = 0;
    let height = 0;

    const steps = Object.entries(dimensions).reverse();
    for (const step of steps) {
      const [w, size] = step;

      if (windowWidth >= w) {
        width = size[0];
        height = size[1];
        break;
      }
    }

    const key = `${width}x${height}`;
    if (window.__TGV_MAP_URLS && window.__TGV_MAP_URLS[key]) {
      const url = window.__TGV_MAP_URLS[key];
      $mapStaticImg.attr('src', url);
    }
  };

  const loadGoogleMaps = () => {
    if (!window.google || !window.google.maps) {
      // load for map modal
      $.getScript(`https://maps.googleapis.com/maps/api/js?v=3.65&loading=async&libraries=marker&language=en&key=${window.GOOGLE_MAPS_API_KEY}`);
    }
  };

  const prepareStaticMap = () => {
    updateStaticMapSize();
  };

  let resizeTimer;
  $(window).on('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(updateStaticMapSize, 250);
  });

  prepareStaticMap();

  window.inView('#room-map').once('enter', () => {
    loadGoogleMaps();

    $mapStaticImg.attr('src', $mapStaticImg.data('src'));
  });
};
